export const environment = {
  baseUrl: 'https://api.dev1.prime.faiplan-dev.com',
  baseAdminUrlClp: 'https://api-snn.dev1.bridge.faiplan-dev.com/adminclp',
  baseUnauthUrl: 'https://api2.dev1.prime.faiplan-dev.com',
  baseUrlCLP: 'https://api.dev1.bridge.faiplan-dev.com/clp',
  baseUrlDUU: 'https://api.dev1.bridge.faiplan-dev.com',
  lensSenderEmail: 'snn-no.reply@dev1.prime.faiplan-dev.com',
  identityPoolId: 'us-east-2:80bdb9d1-e0de-4041-a448-20f98f7d45be',
  userPoolId: 'us-east-2_yy7cS20Gp',
  userPoolWebClientId: '49oi3hq1sdptatn0437mgn5tqi', //LensAppClient_WEB
  userPoolAwsLogin: 'cognito-idp.us-east-2.amazonaws.com/us-east-2_yy7cS20Gp',
  region: 'us-east-2',
  production: true,
  locales: ['en'],
  defaultLocale: 'en',
  backendUrl: 'https://api.dev1.prime.faiplan-dev.com/hil',
  backendUrlLogger: 'https://api.dev1.prime.faiplan-dev.com/logger',
  bucketForMask: 'prime-dev1-bucket-samd-segmentation-image-repo',
  bucketForImage: 'prime-dev1-bucket-samd-raw-image-repo',
  bucketForTibiaMask: 'prime-dev1-bucket-samd-segmentation-image-repo-tibia',
  bucketForTibiaImage: 'prime-dev1-bucket-samd-raw-image-repo-tibia',  
  hostedUIUrl: 'https://bridge-dev1-snn-auth.auth.us-east-2.amazoncognito.com/oauth2/', //Bridge SSN Cognito URL
  hostedUIlogout: 'https://bridge-dev1-snn-auth.auth.us-east-2.amazoncognito.com/logout', //Bridge SSN Cognito URL
  maintenanceValue: 'Z8X7C6V5B4N3M2A1S0D9F8G7H6J5K4L3',
  maintenancePublicKey: '-----BEGIN RSA PUBLIC KEY-----\nMIIBCgKCAQEApJFWSRRJMDIX01M9GzIJiFvaIhyDG5qLl1bpw5PhshEMM3ju0DOn\np01q6HxxZYms7ag8z3O0xOrI3QCDD/j68LY9kaANhkQz5rgMGPMFpALMqEQTirQl\nNggQ95l9rvcwoGBnqKUZ24W4ofJVOh6k5YkmCklSRm5RxbA2oPCu+ENywNmrnILW\nfVvShld6R86P0V5md1Fws6oo3DWmyTav/vg4+3nlFwTNcy5vlTOGmMiOLDHhYfbx\nq3fLYnSSPJOMr9GDu921PpAvQsqFrCspu+iMXN759gPVAemSzfh+2KngrhTkZlaO\nqTCt2jYhwObEevpMS7115RFvIYrSEUqxFQIDAQAB\n-----END RSA PUBLIC KEY-----\n',
    ssmParams: {
    MODEL_REQUEST_DELAY: '/prime-dev1/hil-service/ModelRequestDelay',
    BIG_MODEL_REQUEST_DELAY: '/prime-dev1/hil-service/BigModelRequestDelay',
    DEFAULT_NUMBER_OF_ATTEMPTS: '/prime-dev1/hil-service/DefaultNoAttempts',
    APPVERSION: '/prime-dev1/hil-service/hilappVersionInfo',
    PRIMESEGVERSION: '/prime-dev1/hil-service/primesegVersionInfo',
    IDLETIME : '/prime-dev1/hil-service/inactivityTime_login',
    DISABLE_HIL_VALIDATION: '/prime-dev1/hil-service_dev1/disableChecksumForHIL',
    TIBIASEGVERSION: '/prime-dev1/hil-service/tibiasegVersionInfo'
  },
  cloudfrontCLPURL: 'https://snn.dev1.bridge.faiplan-dev.com', //Bridge SNN CF domain name
  cloudFrontCLPSignInUrl: 'https://snn.dev1.bridge.faiplan-dev.com/signin', //Bridge SNN CF domain name
  cloudFrontCLPSignOutUrl: 'https://snn.dev1.bridge.faiplan-dev.com/logout', //Bridge SNN CF domain name
  cloudFrontCLPExitAppUrl: 'https://snn.dev1.bridge.faiplan-dev.com/application/product', //Bridge SNN CF domain name
  hilCloudFrontSigninUrl: 'https://web-portal.dev1.prime.faiplan-dev.com/signin' //Prime CF domain name
};
